import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';

const debug = require('debug')('se:advertitem');

import { Advertisement } from '../../api/adserver';
import { getTopImageUrl } from '../../lib/advert';
import config from '../../lib/config';
import './listItem.css';

export interface Props {
  advert: Advertisement;
  onPress: (item: Advertisement) => void;
  hideText?: boolean;
  margin?: number;
}

const CategoryAdvertListItem: React.FC<Props> = ({ advert, onPress }) => {
  const handleOnPress = () => {
    onPress(advert);
  };

  const topImageUrl = getTopImageUrl(advert);

  return (
    <View style={styles.container}>
      <TouchableOpacity onPress={handleOnPress} style={styles.touchContainer}>
        {topImageUrl && (
          <div className="topImageContainer">
            <img
              alt={advert.headline}
              src={topImageUrl}
              className="spacingImage"
            />
            <div
              className="duplicateImage"
              style={{
                backgroundImage: `url(${topImageUrl})`,
              }}
            />
          </div>
        )}
      </TouchableOpacity>
      <TouchableOpacity onPress={handleOnPress}>
        <View style={styles.headingsDetailContainer}>
          {advert.headline && (
            <Text style={styles.featureHeading}>{advert.headline}</Text>
          )}
          {advert.bi_line && (
            <Text style={[styles.detailText, styles.bottomMargin1Em]}>
              {advert.bi_line}
            </Text>
          )}
        </View>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginBottom: 15,
  },
  touchContainer: {
    flex: 10,
    padding: 0,
    margin: 0,
  },
  headingsDetailContainer: {
    marginTop: 15,
    marginHorizontal: 10,
  },
  slideFeatureContainer: {
    margin: 0,
  },
  mainImage: {},
  detailText: {
    fontSize: 13,
    color: config.theme.advert.subSectionHeadingTextColor,
  },
  bottomMargin1Em: {
    marginBottom: 14,
  },
  featureHeading: {
    fontSize: config.theme.headingFontSize,
    fontWeight: config.theme.headingFontWeight,
    color: config.theme.headingTextColor,
    marginBottom: 10,
  },
});

export default CategoryAdvertListItem;
